import { AppNavParams } from '@euler/app/Routes';
import { ListItemDisclosure } from '@euler/app/components/list/ListItemDisclosure';
import { Typography } from '@euler/app/components/typography';
import { useRecentServiceRecords } from '@euler/app/flows/record/functions/useRecentServiceRecords';
import { TaskDetailSection } from '@euler/app/flows/task/pages/detail/components/TaskDetailSection';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { VehicleServiceRecord } from '@euler/model';
import { WithExtraVehicleModelProps } from '@euler/model/WithExtraVehicleModelProps';
import { formatDateTime } from '@euler/utils/formatters';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { memo, useCallback } from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { RecordsIcon } from './menu-icons/RecordsIcon';

export const RecentServiceRecords = memo(() => {
  const { rpx } = useResponsiveContext();
  const [records] = useRecentServiceRecords();
  const navigation = useNavigation<StackNavigationProp<AppNavParams>>();

  const onPress = useCallback(
    (record: WithExtraVehicleModelProps<VehicleServiceRecord>) => {
      navigation.push('ServiceRecord', { id: record._id });
    },
    [navigation],
  );

  if (!records?.length) {
    return null;
  }

  return (
    <TaskDetailSection
      title="历史记录"
      noBodyPadding
      headerStyle={{ borderBottomWidth: 0 }}
      css={`
        margin-bottom: ${rpx(15)}px;
      `}
    >
      {records.map(record => (
        <ServiceRecordCell record={record} key={record._id} onPress={onPress} />
      ))}
    </TaskDetailSection>
  );
});

export const ServiceRecordCell = memo(
  ({
    record,
    style,
    onPress,
  }: {
    record: WithExtraVehicleModelProps<VehicleServiceRecord>;
    style?: StyleProp<ViewStyle>;
    onPress?: (
      record: WithExtraVehicleModelProps<VehicleServiceRecord>,
    ) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const handlePress = useCallback(() => {
      onPress?.(record);
    }, [onPress, record]);
    return (
      <TouchableOpacity
        css={`
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: ${rpx(10)}px ${rpx(6)}px ${rpx(10)}px ${rpx(15)}px;
          border-top-width: 1px;
          border-top-color: #e7e7e7;
        `}
        style={style}
        onPress={handlePress}
      >
        <RecordsIcon
          size={rpx(44)}
          css={`
            flex-shrink: 0;
          `}
        />
        <View
          css={`
            flex: 1;
            margin-left: ${rpx(10)}px;
          `}
        >
          <Typography.Label medium size={rpx(17)} color="#333">
            {record.mileage}公里
          </Typography.Label>
          <Typography.Label regular size={rpx(15)} color={'#555'}>
            服务门店: {record.storeName}
          </Typography.Label>
          <Typography.Label regular size={rpx(15)} color={'#888'}>
            服务顾问: {record.serviceAgentName}
          </Typography.Label>
          <Typography.Label light size={rpx(15)} color={'#888'}>
            服务时间: {formatDateTime(record.orderedAt)}
          </Typography.Label>
        </View>
        <ListItemDisclosure
          css={`
            flex-shrink: 0;
          `}
        />
      </TouchableOpacity>
    );
  },
);
